import { useEffect, useState } from 'react'
import { getDevicePixelRatio } from '../../helpers/device'

const UseDevicePixelRatio = () => {
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    getDevicePixelRatio(),
  )

  useEffect(() => {
    const handleWindowResize = () => setDevicePixelRatio(getDevicePixelRatio())
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return 1
  // return devicePixelRatio
}

export default UseDevicePixelRatio
